
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nm/news/eric-poe-authority-magazine",
      function () {
        return require("private-next-pages/nm/news/eric-poe-authority-magazine.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nm/news/eric-poe-authority-magazine"])
      });
    }
  